import script from "./uploadSfz.vue?vue&type=script&setup=true&lang=ts"
export * from "./uploadSfz.vue?vue&type=script&setup=true&lang=ts"

import "./uploadSfz.vue?vue&type=style&index=0&id=408569b1&lang=scss"
import "./uploadSfz.vue?vue&type=style&index=1&id=408569b1&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408569b1"]])

export default __exports__